module.exports = __webpack_public_path__ + "static/img/dangerous.28e6ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/dangerous.jpg
// module id = hYBb
// module chunks = 1